export default __webpack_public_path__ + "static/media/Ims.18b3d05d.png";